import { useState } from "react"

import { isNonEmptyArray } from "web/services/helpers"

import routes from "web/routes/constants"

import Header from "./Header"
import Asset from "./Asset"
import Sale from "./Sale"

export default function SaleLocationCard({
  primarySubject,
  location,
  assets,
  assetIds = [],
  sales,
  saleIds = [],
  onItemClick,
  onSelectionChanged,
  onClose,
}) {
  const haveAssets = isNonEmptyArray(assets)
  const haveSales = isNonEmptyArray(sales)

  const numberOfAssets = haveAssets ? assets.length : assetIds.length
  const numberOfSales = haveSales ? sales.length : saleIds.length

  const showToggle = numberOfAssets + numberOfSales > 1
  const selectionEnabledInHeader = numberOfSales === 1

  const [expandedIndex, setExpandedIndex] = useState(numberOfAssets)

  function goToObject(subjectType, id) {
    if (onItemClick) {
      onItemClick(subjectType, id)
    } else if (subjectType === "sale") {
      window.Turbo.visit(`/markets/global/sales/view/${id}`)
    } else {
      window.Turbo.visit(routes.tlo("assets", "all", null, id))
    }
  }

  return (
    <div
      className="mb-4 flex w-64 cursor-pointer flex-col rounded-md bg-white pb-2 shadow-altrio-1"
      style={{ maxHeight: "calc(60vh - 80px)" }}
    >
      <Header
        title={primarySubject.name}
        location={location}
        primarySubject={primarySubject}
        selectionEnabled={selectionEnabledInHeader}
        onSelectionChanged={onSelectionChanged}
        onClick={() => goToObject("sale", primarySubject.id)}
        onClose={onClose}
      />
      <div className="flex-grow overflow-y-auto">
        {(haveAssets ? assets : assetIds).map((el, i) => {
          return (
            <Asset
              key={i}
              asset={haveAssets ? el : undefined}
              assetId={!haveAssets ? el : undefined}
              location={location}
              showToggle={showToggle}
              isExpanded={expandedIndex === i}
              selectionEnabled={false}
              onToggle={() => setExpandedIndex(i)}
              onClick={() => goToObject("asset", haveAssets ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
        {(haveSales ? sales : saleIds).map((el, i) => {
          const saleIndex = numberOfAssets + i

          return (
            <Sale
              key={i}
              sale={haveSales ? el : undefined}
              saleId={!haveSales ? el : undefined}
              showToggle={showToggle}
              isExpanded={expandedIndex === saleIndex}
              selectionEnabled={!selectionEnabledInHeader} // TODO: change for others
              onToggle={() => setExpandedIndex(saleIndex)}
              onClick={() => goToObject("sale", haveSales ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
      </div>
    </div>
  )
}
